<template>
<div class="row">
  <div class="col-xs-12">
    <p style="color: #aaaaaa; margin-bottom: 1em; text-align: right; font-size: 5pt;"> {{ `${eventId}-${ticketId}` }} </p>
  </div>
  <div class="col-xs-12">
    <div class="row">
      <div class="col-xs-4 text-center">
        <img :src="imgsrc" style="max-height: 60px;">
      </div>
      <div class="col-xs-4 text-center"><h3> {{ title }} </h3></div>
      <div class="col-xs-4"></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'header-delivery-term',

  props: {
    imgsrc: {
      required: true
    },
    eventId: {
      required: true
    },
    ticketId: {
      required: true
    },
    title: {
      default: 'Protocolo de Entrega'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/HeaderTerm.vue